<script setup></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.04688 8.95301V8.95301C8.02319 9.92932 9.6061 9.92932 10.5824 8.95301L12.6711 6.86434C13.6474 5.88803 13.6474 4.30511 12.6711 3.3288V3.3288C11.6948 2.35249 10.1119 2.35249 9.13555 3.3288L8.00012 4.46423"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.67089 7.32873V7.32873C7.69458 6.35242 6.11167 6.35242 5.13536 7.32873L3.04669 9.4174C2.07038 10.3937 2.07038 11.9766 3.04669 12.9529V12.9529C4.023 13.9292 5.60591 13.9292 6.58222 12.9529L7.71765 11.8175"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss"></style>
